import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';

import { BreadcrumbGroup, Checkbox, FormField, Header, List, Popover, Select, SpaceBetween } from '@cloudscape-design/components';
import Calendar from '@fullcalendar/react';
import resourceTimelinePlugin from '@fullcalendar/react-scheduler/resource-timeline';
import interactionPlugin from '@fullcalendar/react/interaction';
import '@fullcalendar/react/skeleton.css';
import themePlugin from '@fullcalendar/react/themes/classic';
import '@fullcalendar/react/themes/classic/palette.css';
import '@fullcalendar/react/themes/classic/theme.css';

import { mdiAccountMultiple, mdiHumanMaleBoard, mdiInformation, mdiTagHidden } from '@mdi/js';
import Icon from '@mdi/react';
import { addYears, endOfDay, format, isAfter, isBefore, isEqual, parse, parseISO, startOfDay } from 'date-fns';
import '../../../../../../src/components/css/FullCalendar.css';
import DPModal from '../../../../../components/DPModal';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Booking from '../../../../../components/extras/Booking';
import Confirm from '../../../../../components/extras/Confirm';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemBooking, ItemEquipment } from '../../../../../resources/types';
import { buildBreadcrumbItems, getCookie, getUrlVersion, getUser, setLoading, setParameters } from '../../../../commons/functions';
import { CustomAppLayout } from '../../../layout';
// TEMPORARILY REMOVE MONARCH


const STATIC_RESOURCES = [
    { id: '1', title: 'CC-AJQ' },
    { id: '2', title: 'CC-AJQ2' },
];

const EMPTY_EVENTS: any[] = [];

export const Template: React.FC = () => {
    const { menu, parameters, idUser, data } = useGlobalState();
    const [onlyBookings, setOnlyBookings] = useState(false);
    const [showPrivates, setShowPrivates] = useState(false);
    const [bookings, setBookings] = useState<any[]>([]);
    const [blockings, setBlockings] = useState<any[]>([]);
    const [equipments, setEquipments] = useState<ItemEquipment[]>([]);
    const [booking, setBooking] = useState<any>();
    const [info, setInfo] = useState<any>();
    const [totalHeight, setTotalHeight] = useState(1);
    const [index, setIndex] = useState(0);
    const calendarRef = useRef(null);


    const formattedDate = parameters.date
        ? format(parse(parameters.date, "dd-MM-yyyy", new Date()), "yyyy-MM-dd")
        : null;

    useEffect(() => {
        if (formattedDate && calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            calendarApi.gotoDate(formattedDate);
        }
    }, [formattedDate]);
    const handleDateClick = (info: any) => {
        const targetDate = new Date(info.date);
        const resourceProps = info?.resource?.extendedProps;
        const eq = info?.resource?.extendedProps;

        console.log("info.resource:", info?.resource);



        if (info.resource.extendedProps.jsonOwners.length > 0 && !info.resource.extendedProps.jsonOwners.includes(idUser)) {
            console.log("Reason: User is not an owner");
            return;
        }

        if (isBefore(targetDate, startOfDay(new Date()))) {
            console.log("Reason: Date is before today");
            return;
        }
        const parseCustomDate = (str: any) => {
            if (!str || typeof str !== 'string') return null;
            const trimmed = str.trim();

            // 1. Check if ISO string (contains 'T')
            if (trimmed.includes('T')) {
                const parsedISO = parseISO(trimmed);
                return isNaN(parsedISO.getTime()) ? null : parsedISO;
            }

            // 2. Check string formats based on character patterns
            let formatString = 'dd-MM-yyyy';

            if (trimmed.includes(' ')) {
                const timePart = trimmed.split(' ')[1];
                const colons = (timePart.match(/:/g) || []).length;

                if (colons === 2) {
                    formatString = 'dd-MM-yyyy HH:mm:ss';
                } else if (colons === 1) {
                    formatString = 'dd-MM-yyyy HH:mm';
                }
            }

            const parsed = parse(trimmed, formatString, new Date());
            return isNaN(parsed.getTime()) ? null : parsed;
        };

        const isDateInRange = (target: any, startStr: any, endStr: any) => {
            const rawStart = parseCustomDate(startStr);
            const rawEnd = parseCustomDate(endStr);

            const startHasTime = Boolean(startStr && (startStr.includes('T') || startStr.includes(' ')));
            const endHasTime = Boolean(endStr && (endStr.includes('T') || endStr.includes(' ')));

            const startDate = rawStart && !startHasTime ? startOfDay(rawStart) : rawStart;
            const endDate = rawEnd && !endHasTime ? endOfDay(rawEnd) : rawEnd;

            // Inclusive start: A blocking starting at 13:00 blocks 13:00 (target >= start)
            const isAfterOrEqual = (t: any, s: any) => isAfter(t, s) || isEqual(t, s);

            // Exclusive end when time is provided: A blocking ending at 13:00 DOES NOT block 13:00 (target < end)
            const isStrictlyBefore = (t: any, e: any) => isBefore(t, e);

            if (startDate && endDate) {
                // If end has time, use strict < ; if date-only (23:59:59), use <=
                const endValid = endHasTime ? isStrictlyBefore(target, endDate) : (isBefore(target, endDate) || isEqual(target, endDate));
                return isAfterOrEqual(target, startDate) && endValid;
            } else if (startDate) {
                return isAfterOrEqual(target, startDate);
            } else if (endDate) {
                return endHasTime ? isStrictlyBefore(target, endDate) : (isBefore(target, endDate) || isEqual(target, endDate));
            }
            return false;
        };
        if (resourceProps.isOutOfFlight === 1) {
            const { outOfFlightStart, outOfFlightEnd } = resourceProps;
            if (outOfFlightStart === "" && outOfFlightEnd === "") {
                console.log("Reason: Out of flight complete");
                return;
            }
            if (outOfFlightStart || outOfFlightEnd) {
                if (isDateInRange(targetDate, outOfFlightStart, outOfFlightEnd)) {
                    console.log("Reason: Out of flight single");
                    return;
                }
            }
        }

        // 3. Check Resource Blockings

        if (Array.isArray(blockings) && blockings.length > 0) {
            const hasActiveBlocking = blockings
                .filter((e: any) => e.idEquipment === resourceProps.idEquipment)
                .some((blocking) => {
                    const { startDateTime, endDateTime } = blocking;
                    console.log(targetDate, startDateTime, endDateTime)
                    if (!startDateTime && !endDateTime) return false;
                    return isDateInRange(targetDate, startDateTime, endDateTime);
                });
            if (hasActiveBlocking) {
                console.log("Reason: Active blocking");
                return;
            }
        }

        setInfo({
            date: format(info.date, "dd-MM-yyyy"),
            startTime: format(info.date, "H"),
            idEquipment: info.resource.extendedProps.idEquipment,
            registration: info.resource.extendedProps.registration,
            idGroupType: info.resource.extendedProps.idGroupType,
        });
        //http://[::1]:9616/#members/bookings/book?date=10-10-2026&idGroupType=1044
    };
    const handleEquipments = async () => {

        try {
            setBookings([]);
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/equipments/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    isBookCapable: 1,
                    isClubOrOwner: 1,
                    columns: "idEquipment, registration, equipment, isOutOfFlight, jsonOwners, outOfFlightStart, outOfFlightEnd, idGroupType, groupType",
                    orderBy: "registration",
                    order: "asc",
                    orderBy2: "equipment",
                    order2: "asc",
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.equipments) {
                setEquipments(data.equipments);
            }

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }

    };

    const handleRefresh = async () => {
        if (parameters && parameters.date && parameters.date !== "") {
            try {
                setBookings([]);
                setLoading(true);
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/bookings/list',
                        'JWT': getCookie("JWT"),

                    },
                    body: JSON.stringify({
                        dateBetween: parameters.date,
                        blockings: true,
                        orderBy: "ordenGroupType",
                        order: "ASC",
                        orderBy2: "dateEnd",
                        order2: "ASC"
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const data = await response.json();
                if (data && data.bookings) {
                    setBookings(data.bookings);
                }
                if (data && data.blockings) {
                    setBlockings(data.blockings);
                }

            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        handleRefresh();
    }, [parameters.date]);
    useEffect(() => {
        handleEquipments();
    }, []);


    const filterBlockings = useMemo(() => {
        if (!blockings) return [];
        return blockings
            .map((b: any) => ({
                title: b.reason,
                type: "lock",
                classNames: ['bg-transparent'],
                backgroundColor: "transparent",
                borderColor: "transparent",
                resourceId: `eq${b.idEquipment}`,
                start: parse(`${b.startDateTime}`, "dd-MM-yyyy HH:mm", new Date()),
                end: parse(`${b.endDateTime}`, "dd-MM-yyyy HH:mm", new Date()),
            }));
    }, [blockings]);

    const filterBookings = useMemo(() => {
        if (!bookings) return [];
        return bookings;
        return bookings.filter(
            (booking) => booking.idGroupType === parameters.idGroupType
        );
    }, [bookings, parameters.idGroupType]);


    const filteredEquipments = useMemo(() => {
        if (!equipments) return [];

        return equipments
            .filter((eq: ItemEquipment) => {
                // Check bookings condition
                if (onlyBookings && !bookings?.some((b: any) => b.idEquipment === eq.idEquipment)) {
                    return false;
                }

                // Check showPrivates condition:
                // If showPrivates is false, only keep equipments with no owners
                if (!showPrivates && eq.jsonOwners.length > 0) {
                    return false;
                }
                if (parameters.idGroupType && eq.idGroupType !== parameters.idGroupType) {
                    return false;
                }

                return true;
            })
            .map((eq: ItemEquipment) => ({
                id: `eq${eq.idEquipment.toString()}`,
                title: eq.equipment !== "" ? eq.equipment : eq.registration,
                groupId: eq.groupType,
                ...eq,
            }));
    }, [equipments, bookings, onlyBookings, showPrivates, parameters?.idGroupType]);

    useEffect(() => {
        filteredEquipments.length > 0 ?
            setTotalHeight(filteredEquipments.length * 77 + 73 + 5) : 1
    }, [filteredEquipments]);
    const filteredOOF =
        equipments.filter((eq: any) => eq.isOutOfFlight === 1)
            .map((b: any) => ({
                title: "FDV",
                type: "oof",
                classNames: ['bg-transparent'],
                backgroundColor: "transparent",
                borderColor: "transparent",
                resourceId: `eq${b.idEquipment}`,
                start: b.outOfFlightStart !== "" ? parse(`${b.outOfFlightStart}`, "dd-MM-yyyy", new Date()) : addYears(new Date(), -10),
                end: b.outOfFlightEnd !== "" ? parse(`${b.outOfFlightEnd}`, "dd-MM-yyyy", new Date()) : addYears(new Date(), 10),
            }));
    const filteredBookings =
        bookings?.flatMap((b: any) => {
            // Standard booking event
            const bookingEvent = {
                title: b.displayName,
                type: "booking",
                classNames: ['bg-transparent'],
                backgroundColor: "transparent",
                borderColor: "transparent",
                resourceId: `eq${b.idEquipment}`,
                start: parse(`${b.dateStart} ${b.timeStart}`, "dd-MM-yyyy HH:mm", new Date()),
                end: parse(`${b.dateEnd} ${b.timeEnd}`, "dd-MM-yyyy HH:mm", new Date()),
                booking: b,
            };


            return [bookingEvent];
        }) || [];
    const allEvents = [...filterBlockings, ...filteredOOF, ...filteredBookings];
    const documentWidth = useDocumentWidth();
    return (
        <>
            <style>{`
        /* 1. Collapse only the indent spacer to 0 width */
        .hidden-resource-indent {
          width: 0px !important;
          min-width: 0px !important;
          max-width: 0px !important;
          padding: 0 !important;
          margin: 0 !important;
          display: none !important;
        }

      `}</style>
            <CustomAppLayout
                toolsHide={true}
                breadcrumbs={
                    <BreadcrumbGroup
                        items={buildBreadcrumbItems(menu)}
                        expandAriaLabel="Show path"
                        ariaLabel="Breadcrumbs"
                    />
                }
                content={
                    <SpaceBetween size="s">
                        <Header variant="h1" actions={<Favorites />}>Template</Header>
                        <SpaceBetween size="s" direction="vertical">
                            <SpaceBetween size="s" direction="horizontal">
                                <FormField label="Fecha">

                                    <DPModal width={105} today date={parameters.date} clear={false} tomorrow onConfirm={(date) => {
                                        if (date !== "") {
                                            const updatedParameters = {
                                                ...parameters, // clone existing keys
                                                date: (date) // add or update
                                            };
                                            setParameters(updatedParameters);
                                        }
                                    }} />
                                </FormField>
                                <FormField label="Tipo">
                                    <Select
                                        options={[
                                            { label: "Todos", value: "0" },
                                            ...(data?.groupTypes?.filter((g: any) => g.showOnBooking === 1) // filter out any falsy values before mapping
                                                .map((g: any) => ({
                                                    label: g.groupType,
                                                    value: String(g.idGroupType)
                                                })) || [])
                                        ]}
                                        selectedOption={
                                            Number(parameters.idGroupType) === 0
                                                ? { label: "Todos", value: "0" }
                                                : (() => {
                                                    const selected = data?.groupTypes?.find(
                                                        (g: any) => Number(g.idGroupType) === Number(parameters.idGroupType)
                                                    );
                                                    return selected
                                                        ? { label: selected.groupType, value: String(selected.idGroupType) }
                                                        : { label: "Todos", value: "0" };
                                                })()
                                        }
                                        onChange={(value) => {
                                            const selectedVal = Number(value.detail.selectedOption.value);
                                            console.log("Selected option:", selectedVal);
                                            setParameters({ ...parameters, idGroupType: selectedVal });
                                        }}
                                    />
                                </FormField>
                            </SpaceBetween>

                            <SpaceBetween size="s" direction="horizontal">

                                <Checkbox checked={onlyBookings} onChange={({ detail }) => setOnlyBookings(!onlyBookings)}>Solo reservas</Checkbox>
                                <Checkbox checked={showPrivates} onChange={({ detail }) => setShowPrivates(!showPrivates)}>
                                    Ver privados<Icon path={mdiTagHidden} size={0.8} />
                                </Checkbox>


                                {/*<Button onClick={handleButtonClick}>Refresh Equipments</Button>*/}
                            </SpaceBetween>
                        </SpaceBetween>

                        <div
                            id="calendar-debug-wrapper"
                            style={{
                                minWidth: documentWidth < 500 ? "95vw" : "500px",
                                //height: `${totalHeight}px`,
                                overflow: "hidden",
                                width: "100%"
                            }}
                        >
                            <Calendar
                                initialView="resourceTimelineDay"
                                ref={calendarRef}
                                plugins={[interactionPlugin, themePlugin, resourceTimelinePlugin]}
                                events={allEvents}
                                resources={filteredEquipments}
                                headerToolbar={false}
                                initialDate={formattedDate}
                                firstDay={1}
                                slotMinTime="08:00:00"
                                slotMaxTime="22:00:00"
                                resourceColumnsWidth="120px"
                                resourceColumnHeaderContent="Horario"
                                locale='es'
                                resourceGroupField='groupId'
                                resourceIndentClass="hidden-resource-indent"
                                //resourceExpanderClass="hidden-resource-expander"
                                eventContent={(eventInfo) => renderEventContent(eventInfo, parameters.theme)}
                                tableHeaderSticky
                                slotDuration="01:00:00"
                                slotHeaderInterval="01:00:00"
                                slotHeaderFormat={{
                                    hour: 'numeric',
                                    minute: '2-digit',
                                    meridiem: 'short',
                                    hour12: false
                                }}
                                //editable
                                selectable
                                resourcesInitiallyExpanded
                                dateClick={handleDateClick}
                                resourceOrder="registration, equipment"
                                eventColor={"transparent"}
                                colorScheme={parameters.theme === "dark" ? "dark" : "light"}

                                resourceColumns={[
                                    {
                                        //field: 'title',
                                        headerContent: '·',
                                        cellContent: (arg: any) => (
                                            <div style={{ fontWeight: 'bold' }}>
                                                {arg.resource.title}
                                                <br />

                                                {/* Badge for Out of Flight */}
                                                {arg.resource.extendedProps.isOutOfFlight !== 0 && (
                                                    <BadgeCustom size="small" color="red">
                                                        <Popover
                                                            header="Fuera de vuelo"
                                                            renderWithPortal
                                                            content={(() => {
                                                                const start = arg.resource.extendedProps.outOfFlightStart;
                                                                const end = arg.resource.extendedProps.outOfFlightEnd;
                                                                const startText = start ? ` desde el ${start}` : "";
                                                                const endText = end ? ` hasta el ${end}` : "";
                                                                return `Material se encuentra fuera de vuelo${startText}${endText}`.trim();
                                                            })()}
                                                        >
                                                            FDV
                                                        </Popover>
                                                    </BadgeCustom>
                                                )}

                                                {/* Popover for Owners */}
                                                {arg.resource.extendedProps.jsonOwners?.length > 0 ? (
                                                    <Popover
                                                        renderWithPortal
                                                        header="Propietarios"
                                                        content={
                                                            <SpaceBetween direction='vertical' size="s">
                                                                <List
                                                                    items={arg.resource.extendedProps.jsonOwners.map((idUser: any) => {
                                                                        const user = getUser(idUser, data);
                                                                        const displayName = user?.name ?? user?.displayName ?? idUser;

                                                                        return {
                                                                            id: `usr${idUser}`,
                                                                            userName: displayName,
                                                                        };
                                                                    })}
                                                                    renderItem={(item: any) => ({
                                                                        id: item.id,
                                                                        content: `${item.userName}`,
                                                                    })}
                                                                />
                                                            </SpaceBetween>
                                                        }
                                                    >
                                                        <Icon path={mdiTagHidden} size={0.8} />
                                                    </Popover>
                                                ) : null}
                                            </div>
                                        )
                                    }
                                ]}

                                eventClick={(info) => {
                                    info.jsEvent.preventDefault();
                                    const booking = info.event.extendedProps.booking as ItemBooking;
                                    setBooking(booking);
                                }}
                                height={"auto"}
                            />
                        </div>
                        {!!booking && (
                            <Booking
                                booking={booking}
                                idUser={idUser}
                                onDelete={() => setBooking(null)}
                                onDismiss={() => setBooking(null)}
                            />
                        )}
                        {!!info && (
                            <Confirm
                                type="info"
                                onDismiss={() => setInfo(null)} show={!!info} action={'Reservar'}
                                warning={`Ir a reservar el ${info?.registration} el ${info?.date} desde las ${info?.startTime}:00`}
                                onConfirm={() => {
                                    window.location.hash = `#members/bookings/book?date=${info?.date}&idGroupType=${info?.idGroupType}&idEquipment=${info?.idEquipment}&startTime=${info?.startTime}`;
                                }}
                            />
                        )}
                    </SpaceBetween>
                }
            />
        </>
    )
};

function renderEventContent(eventInfo: any, theme: string) {

    const booking = eventInfo.event.extendedProps.booking as ItemBooking;
    const data = eventInfo.event.extendedProps.booking as any;
    const towType = {
        MOUNTAIN: <BadgeCustom color="lime">C</BadgeCustom>,
        SANRAMON: <BadgeCustom color="violet">SR</BadgeCustom>,
        LOCAL: <BadgeCustom color="brown">LC</BadgeCustom>,
        NONE: <BadgeCustom color="grey">AD</BadgeCustom>,
        BALLAST: <BadgeCustom color="violet">LA</BadgeCustom>
    }
    return (
        eventInfo.event.extendedProps.type == "lock" ? (
            <div style={{
                border: "orange",
                backgroundColor: "orange",
                borderRadius: "4px",
                padding: "1px 2px 1px 5px",
                height: '18px',
                width: '100%',
                textAlign: 'center'
            }}>
                <Popover renderWithPortal header="Bloqueado" content={eventInfo.event.title}>Bloqueado</Popover>
            </div>) :
            eventInfo.event.extendedProps.type == "oof" ? (

                <div style={{
                    border: "red",
                    backgroundColor: "red",
                    borderRadius: "4px",
                    height: '5px',
                    width: '100%',
                }}>

                </div>
            ) : (
                <div style={{
                    border: theme === "dark" ? "1px solid #444" : "1px solid #eaeaea",
                    backgroundColor: theme === "dark" ? "#333" : "#eaeaea",
                    borderRadius: "4px",
                    padding: "2px",
                    maxHeight: '60px',
                    width: '100%',
                    overflow: 'hidden',
                    boxSizing: 'border-box'
                }}>
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: theme === "dark" ? "white" : "black" }}>
                        <strong>{booking.displayName}</strong>
                    </div>

                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        minWidth: 0, // 🔑 Essential for flex child truncation/clipping
                        color: theme === "dark" ? "white" : "black"
                    }}>
                        {
                            data.instructor && data.instructor !== '' ? (
                                <Popover header="Instructor" content={data.instructor}>
                                    <Icon path={mdiHumanMaleBoard} size={0.8} />
                                </Popover>
                            ) : null}
                        {data.equipmentType === "GLIDER" && (
                            <span key={`DV${data.idBooking}`}>{towType[data.towType as keyof typeof towType]}</span>
                        )}
                        <BadgeCustom key={`BT${data.idBooking}`} color={data.bookingTypeBadge}>{data.bookingType.substring(0, 1)}</BadgeCustom>


                        {data.obsBooking && data.obsBooking !== '' ? (
                            <Popover
                                triggerType="custom"
                                // 🔑 CRITICAL FIX: Add the key here!
                                key={`POPOVER${data.idBooking}`}
                                dismissButton={false}
                                position="top"
                                size="small"
                                header='Observaciones'
                                content={data?.obsBooking}
                            >
                                <BadgeCustom color="grey" key={`OBS${data.idBooking}`}>
                                    <Icon path={mdiInformation} size={0.75} />
                                </BadgeCustom>
                            </Popover>

                        ) : null}
                        {data.pax > 0 ? <BadgeCustom color="grey" key={`OBS${data.idBooking}`}><Icon path={mdiAccountMultiple} size={0.6} />X{data.pax}</BadgeCustom> : null}
                    </div>
                </div>

            )
    );
}

function useDocumentWidth() {
    const [width, setWidth] = useState<number>(0);

    useEffect(() => {
        const updateWidth = () => {
            // clientWidth excludes scrollbars (most common choice for document layout)
            const docWidth = document.documentElement.clientWidth || document.body.clientWidth;
            setWidth(docWidth);
        };

        // Set initial width
        updateWidth();

        // Listen for window resize
        window.addEventListener('resize', updateWidth);

        // Clean up event listener on unmount
        return () => window.removeEventListener('resize', updateWidth);
    }, []);

    return width;
}